// services/functions/getAdminUserProfile.ts - typed wrapper around
// the getAdminUserProfile callable. Returns the merged user / profile
// / entitlement shape the admin dashboard renders.

import { httpsCallable } from 'firebase/functions';
import { functions } from '@/services/firebase';

interface Input {
  uid: string;
}

export interface AdminUserProfilePurchase {
  productId: string;
  status: string;
  purchasedAt: string | null;
  expiresAt: string | null;
  source: string;
}

export interface AdminUserProfile {
  uid: string;
  displayName: string | null;
  email: string | null;
  avatarUrl: string | null;
  bannerUrl: string | null;
  isAnonymous: boolean;
  isDeleted: boolean;
  isPaying: boolean;
  createdAt: string | null;
  revenueCatId: string | null;
  countryCode: string | null;
  currency: string | null;
  priceLocal: number | null;
  priceUsd: number | null;
  taxPercentage: number | null;
  commissionPercentage: number | null;
  offerCode: string | null;
  isFamilyShare: boolean;
  purchases: AdminUserProfilePurchase[];
  revenueLocal: number | null;
  revenueUsd: number | null;
}

const callable = httpsCallable<Input, AdminUserProfile>(
  functions,
  'getAdminUserProfile',
);

export async function getAdminUserProfile(uid: string): Promise<AdminUserProfile> {
  const res = await callable({ uid });
  return res.data;
}
